import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { HashRouter } from "react-router-dom";
/* istanbul ignore next */
const root = ReactDOM.createRoot(document.getElementById('root'));
/* istanbul ignore next */
root.render(
  <><GoogleOAuthProvider clientId="1003534036288-tgapavgblinbolkdj7kirm5alafkj2uj.apps.googleusercontent.com">
    <React.StrictMode>
    <HashRouter>

    <App />
    </HashRouter>
  </React.StrictMode>
    </GoogleOAuthProvider>
    </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
/* istanbul ignore next */
reportWebVitals();
